import classes from './ButtonEdit.module.css'




const ButtonEdit = ({label} : {label: string}) => {
    return (
        <button  className={`${classes.btn} ${classes.btn_1}`}>
        <svg>
            <rect x="0" y="0" fill="none" width="100%" height="100%"/>
        </svg>
        {label}
        </button>
    )
}


export default ButtonEdit